// extracted by mini-css-extract-plugin
module.exports = {"label":"SystemSettingsPage_label__2IGn3"};